import { connect } from "react-redux";
import ListVariablesComponent from "../../Components/Variables/ListVariablesComponent";
import { setVariables } from "../../Redux/Actions/VariablesWorkflowsActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
  VARIABLES: state.reducer.VARIABLES,
});

const mapDispatchToProps = (dispatch) => ({
  setVariables: (variables) => dispatch(setVariables(variables)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListVariablesComponent);
